var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-bill-checked-reject',{staticClass:"pt-bill-checked-reject__withData"})
}
var staticRenderFns = []

export { render, staticRenderFns }